import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@prcins/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor(private http: HttpClient) { }

  transferSession(target: string, handler: string): Observable<any> {
    const URL = `${environment.BASE_URL}/session/redirect`;
    let { currentPolicy:selectedPolicy, userId } = sessionStorage;
    return this.http.post(URL, { target, handler, selectedPolicy, userId });
  }

  hydrateSession(session: string): Observable<any> {
    const URL = `${environment.BASE_URL}/session/restore?session=${session}`;
    return this.http.post(URL, {});
  }
}
